<script>
import appConfig from "@/app.config";
import CampaignForm from "@/components/campaign/crud/Form";

export default {
  page: {
    title: "ایجاد کمپین جدید",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    CampaignForm,
  },
  data() {
    return {
      items: [
        {
          text: "مدیریت کمپین ها",
          to: { name: "campaigns" },
        },
        {
          text: "ثبت کمپین جدید",
          active: true,
        },
      ],
    };
  },
  computed: {
    title() {
      return this.$route.params.id !== undefined
        ? "ویرایش کمپین"
        : "ثبت کمپین جدید";
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <CampaignForm :id="$route.params.id" />
  </Layout>
</template>
